import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { message, Switch, Select, Form, Input } from 'antd';
import getUser from '../../hooks/getUser';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { app } from '../../config';
import InputMask from 'react-input-mask';
import { LeftCircleOutlined } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import useFetchRolesByType from '../../hooks/fetchRolesByType';
import useFetchRoles from '../../hooks/fetchRoles';
const { TextArea } = Input;
const Useredit = () => {
  const { t } = useTranslation(['common']);
  const [uploadObj, setUploadObj] = useState({});
  const [phone, setPhone] = useState();
  const [addUserResp,setAddUserResp] = useState({});
  const [pwd,setpwd]=useState('');
  const [confirmPwd,setconfirmPwd]=useState('');
  const [show, setShow] = useState(false); 
  const navigate = useNavigate();
  let userId = JSON.parse(localStorage.getItem('getUserId'));
  let user = JSON.parse(localStorage.getItem('user'));
  let res = getUser(userId);
  let userObj = res.response ? res.response.data : null;
  const token=getTokenfromUserObj();
  console.log(userObj);
  const r = user.userType==="A"?useFetchRoles():useFetchRolesByType();
  console.log(r);
  const roles = r.response ? r.response.data : [];
  console.log(roles);
  const o = useFetchOrganizations();
  const orgs = o.response ? o.response.data : [];
  console.log(orgs);
  const handleChange = (event) => {
    setPhone(event.target.value);
  };
  const uploadData = async (uploadObj) => {
    console.log('Function Running');
    try {
      const res = await axios.post(`${app.URL}/user/updateuser/${userObj.userId}`, uploadObj,{headers:{auth:token}});
      console.log('🚀 ~ file: EditOrg.js:49 ~ uploadData ~ res', res);
      
      if(res.data.statusCode === 200){
        setAddUserResp(res.data)
        setTimeout(()=>{
          
          if(user.userType==="A")navigate('/user/getusers', { replace: true });
          else if(user.userType==="O")navigate('/orguser/view', { replace: true });
        
        },1000)
      }
    } catch (err) {
      window.alert('Something went wrong');
      console.log(err);
    }
  };
  function goBack() {
    if(user.userType==="A")navigate('/user/getusers', { replace: true });
    else if(user.userType==="O")navigate('/orguser/view', { replace: true });
   }
   window.addEventListener('popstate', goBack);
  const onFinish = (values) => {
    console.log('Success:', values);
    if(pwd!==confirmPwd){
      console.log(pwd,confirmPwd);
      message.error("Passwords do not match")
      return; 
    }
    setUploadObj({
      name: values.name ? values.name : userObj.name,
      Password: values.password ? values.password : null,
      phone: phone ? phone : userObj.phone,
      roleId: values.roleId ? values.roleId : userObj.roleId,
      organizationId:  user.userType==="A" && values.organizationId ? values.organizationId : userObj.organizationId,
      isActive: values.isActive === true ? 1 : 0,
      updatedByUserId: user.userId,
    });
    setShow(true);
  };
  console.log(uploadObj);
  const submitData=()=>{
    console.log('calling')  
    if (Object.keys(uploadObj).length > 0) {
      console.log("In upload object")
      console.log(phone);
      if(!phone && userObj.phone.split("_")[0].length<14){
        console.log("A")
        setShow(false);
        message.error('Invalid mobile number')
        return;
      }
      else if(phone&&phone.split("_")[0].length<14){
        setShow(false);
        message.error('Invalid mobile number')
        return;
      }
     else uploadData(uploadObj);
  }
}
const handleClose = () => setShow(false);
const handleShow = () => setShow(true);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div class='col-lg-9 mt-4 '>
         <div class="row topbar " style={{height:"70px",width:"856px"}}>
        <div class='col-lg-4 fs-3 fw-bold'>
        {' '}
        
        <LeftCircleOutlined onClick={()=>{
                if(user.userType==="A")navigate('/user/getusers', { replace: true });
                else if(user.userType==="O")navigate('/orguser/view', { replace: true });
          }} className='mt-3 ml-4 back-icon' style={{ fontSize: '38px'}} />
      </div>
        <div class='col-lg-7 fs-3 fw-bold '>
        <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Update User')} </h2>
        </div>
          {' '}
        </div>
    <div class='card'>
      <div class='card-body p-5'>
   
        <div class='col-lg-10 '>
          {res.response ? (
            <Form
              name='basic'
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 25,
              }}
              style={{
                maxWidth: 600,
              }}
              initialValues={{
                remember: true,
                ['name']: userObj.name,
                ['email']: userObj.email,
                ['phone']: userObj.phone,
                ['roleId']: userObj.roleId,
                ['organizationId']: userObj.organizationId,
                ['isActive']: userObj.isActive === 1 ? true : false,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >
              {user.userType==="A"? <Form.Item
                   colon={false}
                label='Organization'
                name='organizationId'
                rules={[
                  {
                    required: true,
                    message:"Select Organization",
                  },
                ]}
              >
                <Select
                  style={{
                    width: 280,
                  }}
                  placeholder="Select Organization"
                >
                  {orgs
                    ? orgs.map((org) => {
                        return (
                          <Option key={org.organizationId} value={org.organizationId}>
                            {org.organizationName}
                          </Option>
                        );
                      })
                    : ' '}
                </Select>
              </Form.Item> :" "}
                 
              <Form.Item
                   colon={false}
                label='Name'
                name='name'
                defaultValue='1'
                rules={[
                  {
                    required: true,
                    message: 'Input name',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                   colon={false}
                label='Email'
                name='email'
                rules={[
                  {
                    required: true,
                    type: 'email',
                    message: 'Please input your email!',
                  },
                ]}
              >
                <Input disabled={true} />
              </Form.Item>
              <Form.Item
                   colon={false}
                label='Password'
                name='password'
                minLength={8}
                rules={[
                  {
                    required: false,
                    message: 'Input Password!',
                  },
                  {
                    pattern: /[a-z]/,
                    message: 'Password must contain at least one lowercase letter',
                  },
                  {
                    pattern: /[A-Z]/,
                    message: 'Password must contain at least one uppercase letter',
                  },
                  {
                    pattern: /\d/,
                    message: 'Password must contain at least one number',
                  },
                ]}
              >
                <Input.Password onChange={(e)=>setpwd(e.target.value)} />
              </Form.Item>
              <Form.Item
                   colon={false}
                label='Confirm Password'
                name='confirmPassword'
                minLength={8}
                rules={[
                  {
                    required: false,
                    message: 'Input Password!',
                  },
                  {
                    pattern: /[a-z]/,
                    message: 'Password must contain at least one lowercase letter',
                  },
                  {
                    pattern: /[A-Z]/,
                    message: 'Password must contain at least one uppercase letter',
                  },
                  {
                    pattern: /\d/,
                    message: 'Password must contain at least one number',
                  },
                ]}
              >
                <Input.Password onChange={(e)=>setconfirmPwd(e.target.value)} />
              </Form.Item>
              <Form.Item
                   colon={false}
                label='Mobile'
                name='phone'
                rules={[
                  {
                    required: true,
                    message: 'Please enter Mobile.',
                  },
                ]}
              >
                <InputMask mask='(999) 999-9999' onChange={handleChange}>
                  {(inputProps) => <Input {...inputProps} placeholder='Enter Mobile No.' />}
                  {/* <Input /> */}
                </InputMask>
              </Form.Item>
              <Form.Item
                   colon={false}
                label='Role'
                name='roleId'
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  style={{
                    width: 180,
                  }}
                  placeholder="Select Role"
                >
                  {roles.map((role) => {
                    return (
                      <Option key={role.roleId} value={role.roleId}>
                        {role.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item label='Active'     colon={false} valuePropName='checked' name='isActive'>
                <Switch />
              </Form.Item>
              {/* Select box for Role */}
            
              {/* Select box for Organization */}
          
              {/* Outlet Name */}
              {/* <Form.Item
              label='Outlet Name'
              name='outletName'
              rules={[
                {
                  required: false,
                  message: 'Please input your username!',
                },
              ]}
            >
              <Input />
            </Form.Item> */}
              {/* Select box for organization */}
              {/* <Form.Item
              label='Address'
              name='address'
              rules={[
                {
                  required: false,
                  message: 'Please input your address!',
                },
              ]}
            >
              <Input />
            </Form.Item> */}
              {/* Organization */}
              {/* <Form.Item
              label='Organization'
              name='organizationId'
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                listHeight={250}
                listItemHeight={500}
                style={{
                  width: 120,
                }}
              >
                {cities.map((city) => {
                  return (
                    <Option key={city.cityId} value={city.cityId}>
                      {city.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item> */}
              {/* State */}
              {/* <Form.Item
              label='State'
              name='state'
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                listHeight={250}
                listItemHeight={500}
                style={{
                  width: 120,
                }}
              >
                {states.map((state) => {
                  return (
                    <Option key={state.stateId} value={state.stateId}>
                      {state.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item> */}
              {/* Country */}
              {/* <Form.Item
              label='Country'
              name='country'
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                listHeight={250}
                listItemHeight={500}
                style={{
                  width: 120,
                }}
              >
                 {countries.map((country) => {
                  return (
                    <Option key={country.countryId} value={country.countryId}>
                      {country.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              label='Longitude'
              name='longitude'
              rules={[
                {
                  required: false,
                  message: 'Please input your address!',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label='Latitude'
              name='latitude'
              rules={[
                {
                  required: false,
                  message: 'Please input your address!',
                },
              ]}
            >
              <Input />
            </Form.Item> */}

              {/* <Form.Item
              label='Description'
              name='description'
              rules={[
                {
                  message: 'Please input your password!',
                },
              ]}
            >
              <TextArea rows={4} />
            </Form.Item> */}

              <Form.Item
                wrapperCol={{
                  offset: 8,
                  span: 16,
                }}
              >
                                    {addUserResp.statusCode===200? <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body >{addUserResp.message}</Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={()=>{navigate('/organizations/listall')}}>
            Close
          </Button> */}
          {/* <Button variant="primary"  htmlType='submit' onClick={submitData}>
            Save Changes
          </Button> */}
        </Modal.Footer>
      </Modal>:addUserResp.statusCode===400? <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Failed</Modal.Title>
        </Modal.Header>
        <Modal.Body >{addUserResp.data.message}</Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal> : <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body >Are you sure you want to update user?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary"  htmlType='submit' onClick={submitData}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>}
                <button type='primary' class='btn btn-primary button' htmlType='submit'>
             Update
                </button>
              </Form.Item>
            </Form>
          ) : (
            ' '
          )}
        </div>
        {/* 
              <form>
                <div class='form-outline mb-4'>
                  <label class='form-label' for='form3Example1cg'>
                    {t("Id")}
                  </label>
                  <input type='text' name='id' disabled defaultValue={orgObj ? orgObj.organizationId : ' '} id='form3Example1cg' class='form-control form-control-lg' />
                </div>
                <div class='form-outline mb-4'>
                  <label class='form-label' for='form3Example1cg'>
                    {t("Name")}
                  </label>
                  <input type='text' name='organization_name' id='form3Example1cg' defaultValue={orgObj ? orgObj.organizationName : ' '} class='form-control form-control-lg' onChange={handleChange} />
                </div>

                <div class='form-outline mb-4'>
                  <label class='form-label' for='form3Example3cg'>
                    {t("Email")}
                  </label>
                  <input type='email' name='email' id='form3Example3cg' defaultValue={orgObj ? orgObj.email : ' '} class='form-control form-control-lg' onChange={handleChange} />
                </div>

                <div class='form-outline mb-4'>
                  <label class='form-label' for='form3Example3cg'>
                    {t("Description")}
                  </label>
                  <input type='test' name='description' id='form3Example3cg' class='form-control form-control-lg' defaultValue={orgObj ? orgObj.description : ' '} onChange={handleChange} />
                </div>
                <div class='form-check'>
                  <input class='form-check-input' name='is_active' type='checkbox' defaultChecked={checked}  id='flexCheckDefault' onChange={handleCheckChange} />
                  <label class='form-check-label' for='flexCheckDefault'>
             {t("Active")}
                  </label>
                </div>
                <div class='d-flex justify-content-center'>
                  <button type='button' class='btn btn-outline-primary btn-block btn-lg gradient-custom-2 text-body' onClick={handleSubmit}>
                    {t("Edit")}
                  </button>
                </div>
              </form> */}
      </div>
    </div>
    {/*   </div>
      </div>
    </div> */}
    {/* </div> */}
    {/* </section> */}
  </div>

    /* <section class='vh-100 bg-image mt-5' style={{}}>
        <div class='mask d-flex align-items-center h-100 gradient-custom-3'>
          <div class='container h-100'>
            <div class='row d-flex justify-content-center align-items-center h-100'>
              <div class='col-12 col-md-9 col-lg-7 col-xl-6'>
                <div class='card'>
                  <div class='card-body p-5'>
                    <h2 class='text-uppercase text-center mb-5 fw-bold fs-5'>{t("Edit Organization")}</h2>

                    <form>
                      <div class='form-outline mb-4'>
                        <label class='form-label' for='form3Example1cg'>
                          {t("Id")}
                        </label>
                        <input type='text' name='id' disabled defaultValue={orgObj ? orgObj.organization_id : ' '} id='form3Example1cg' class='form-control form-control-lg' />
                      </div>
                      <div class='form-outline mb-4'>
                        <label class='form-label' for='form3Example1cg'>
                          {t("Name")}
                        </label>
                        <input type='text' name='organization_name' id='form3Example1cg' defaultValue={orgObj ? orgObj.organization_name : ' '} class='form-control form-control-lg' onChange={handleChange} />
                      </div>

                      <div class='form-outline mb-4'>
                        <label class='form-label' for='form3Example3cg'>
                          {t("Email")}
                        </label>
                        <input type='email' name='email' id='form3Example3cg' defaultValue={orgObj ? orgObj.email : ' '} class='form-control form-control-lg' onChange={handleChange} />
                      </div>

                      <div class='form-outline mb-4'>
                        <label class='form-label' for='form3Example3cg'>
                          {t("Description")}
                        </label>
                        <input type='test' name='description' id='form3Example3cg' class='form-control form-control-lg' defaultValue={orgObj ? orgObj.description : ' '} onChange={handleChange} />
                      </div>
                      <div class='form-check'>
                        <input class='form-check-input' name='is_active' type='checkbox' defaultChecked={checked}  id='flexCheckDefault' onChange={handleCheckChange} />
                        <label class='form-check-label' for='flexCheckDefault'>
                   {t("Active")}
                        </label>
                      </div>
                      <div class='d-flex justify-content-center'>
                        <button type='button' class='btn btn-outline-primary btn-block btn-lg gradient-custom-2 text-body' onClick={handleSubmit}>
                          {t("Edit")}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */
  );
};

export default Useredit;
